import servicesConfig, { CustomAxiosHeaders } from '../config/services'
import { requests } from '.'
import { AxiosResponse } from 'axios'

const OLD_PRODUCT_ID = 'CONVERSATIONS_AI'
const PRODUCT_ID = 'AI_EMPLOYEE'

// Configure request setup
const serviceName = 'ConversationAIResellingService' 
const host = servicesConfig.Reselling
const opts: CustomAxiosHeaders = { host, serviceName }
const request = (addlOpts?: CustomAxiosHeaders) => {
  return requests(Object.assign({}, opts, addlOpts))
}

// Helper function to handle response
const responseBody = (res: AxiosResponse) => res.data

// Define service object with methods
const ConversationAiResellingService = {
  getProductConfiguration: () =>
    request().get(`/product?productCode=${PRODUCT_ID}`).then(responseBody),

  getConversationsAIProductConfiguration: () =>
    request().get(`/product?productCode=${OLD_PRODUCT_ID}`).then(responseBody),

  getCompanyResellingConfig: (companyId: string) =>
    request().get(`/configuration/company/${companyId}/${PRODUCT_ID}`).then(responseBody),

  updateCompanyResellingConfig: (
    companyId: string,
    data: { amount?: number; offeringEnabled?: boolean }
  ) =>
    request().put(`/configuration/company/${companyId}/${PRODUCT_ID}`, data).then(responseBody),

  getLocationConfig: (locationId: string) =>
    request().get(`/configuration/location/${locationId}/${PRODUCT_ID}`).then(responseBody),

  getLocationSubscriptions: (locationId: string) =>
    request().get(`/subscription/location/${locationId}`).then(responseBody),

  updateLocationResellingConfig: (
    locationId: string,
    data: any
  ) =>
    request().put(`/configuration/location/${locationId}/${PRODUCT_ID}`, data).then(responseBody),

  agencyDirectPurchase: (locationId: string, planId: string, affiliatePayload: any) =>
    request().post(`/subscription/location/${locationId}/${PRODUCT_ID}`, {
      planId: planId,
      purchaseStyle: 'COMPANY_DIRECT_PURCHASE',
      ...affiliatePayload
    }).then(responseBody),

  getCompanySubscriptions: (companyId: string) =>
    request().get(`/subscription/company/${companyId}`).then(responseBody)
}

export default ConversationAiResellingService
